import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchServiceData = createAsyncThunk('services/fetchServiceData', async () => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/services`);
  return response.data;
});

const serviceSlice = createSlice({
  name: 'services',
  initialState: {
    data: null,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchServiceData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchServiceData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default serviceSlice.reducer;
